import React, { useState } from "react";
import Sidebar from "../../../component/home/sidebar";
import CustomizationIndex from "./CustomizationIndex";
import EmailTemplate from "./EmailTemplate";

const WhiteLabeling = () => {
  const [tab, setTab] = useState(1);
  return (
    <>
      <div className="mt-4 sm:mx-6 lg:mx-8">
        <div
          className="flex flex-col md:flex-row"
          style={{ height: "calc(100vh - 70px)" }}
        >
          <Sidebar />
          {/* md:w-2/3 */}
          <div className="flex-auto px-5 bg-white max-h-full w-full  space-y-8 relative mt-3">
            {/* md:w-2/3 */}
            <div className="flex-auto px-5 pb-5 bg-white max-h-full w-full">
              <div className={`w-full sm:block min-h-100 mb-5`}>
                {/* ------------------------------- Tabs ------------------------- */}
                <div className={`sm:block sm:pt-1`}>
                  <ul
                    className="text-sm font-medium flex flex-nowrap overflow-x-scroll no-scrollbar border-b border-b-[#D9D9D9] space-x-12"
                    id="tabs-tabJustify"
                    role="tablist"
                  >
                    <li className="text-left">
                      <a
                        href="#users"
                        className={` w-full block whitespace-nowrap text-sm leading-3 font-semibold  py-2 my-3" +
                ${
                  tab === 1
                    ? "border-b-2 border-[--bg-color-500] text-[--bg-color-500]"
                    : ""
                }`}
                        id="users"
                        data-toggle="tab"
                        role="tablist"
                        onClick={(e) => {
                          e.preventDefault();
                          setTab(1);
                        }}
                      >
                        Interface Design
                      </a>
                    </li>
                    <li className="text-left">
                      <a
                        href="#collaborators"
                        className={` w-full block whitespace-nowrap text-sm leading-3 font-semibold py-2 my-3" +
                  ${
                    tab === 2
                      ? "border-b-2 border-[--bg-color-500] text-[--bg-color-500]"
                      : ""
                  }`}
                        id="collaborators"
                        data-toggle="tab"
                        role="tablist"
                        onClick={(e) => {
                          e.preventDefault();
                          setTab(2);
                        }}
                      >
                        Email Template
                      </a>
                    </li>
                  </ul>
                </div>
                {tab === 1 && <CustomizationIndex />}
                {tab === 2 && <EmailTemplate />}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

WhiteLabeling.auth = {
  path: "/customization",
  role: ["super-admin", "admin"],
};

export default WhiteLabeling;
